import { createFileRoute } from '@tanstack/react-router';

import { naturalPersonDetailScreen, loadPersonMessages, loadPersonScreens, personDetailSearch } from '@/modules/person/route';
import { lazyScreen } from '@/shared/screen';

export const Route = createFileRoute('/_app/pessoas-fisicas/todas/$personId/')({
  validateSearch: personDetailSearch,
  staticData: { screen: naturalPersonDetailScreen },
  loader: () => loadPersonMessages(),
  component: lazyScreen(loadPersonScreens, 'NaturalPersonDetailPage'),
});
